import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadMenus } from '../../../redux/WithcookieSlice';
import { setMenus } from '../../../redux/editorSlice';

const MenuDebug = () => {
  const dispatch = useDispatch();
  
  // Redux에서 메뉴 데이터 가져오기
  const globalMenus = useSelector(state => state.withcookie?.globalMenus);
  const mainMenus = useSelector(state => state.withcookie?.mainMenus);
  const editorMenus = useSelector(state => state.editor?.menus);
  
  // 컴포넌트 마운트 시 메뉴 데이터 로드하기
  useEffect(() => {
    
    // withcookieSlice의 loadMenus 액션 디스패치
    dispatch(loadMenus())
      .then(() => {
      })
      .catch(error => {
        console.error('메뉴 로드 실패:', error);
      });
      
   
    
    // 5초 후 한번 더 메뉴 데이터를 확인하고 필요한 경우 메뉴 설정
    const timeout = setTimeout(() => {
      
      
      // 만약 에디터 메뉴가 있지만 withcookie 메뉴가 없는 경우, 에디터 메뉴 데이터를 withcookie의 메뉴로 복제
      if (Array.isArray(editorMenus) && editorMenus.length > 0 && 
         (!Array.isArray(globalMenus) || globalMenus.length === 0) && 
         (!Array.isArray(mainMenus) || mainMenus.length === 0)) {
        
        
        // 메뉴 타입별로 구분하여 저장
        const newGlobalMenus = editorMenus.filter(menu => menu.type === 'GLOBAL');
        const newMainMenus = editorMenus.filter(menu => menu.type === 'MAIN' || !menu.type);
        
  
        
        // 수동으로 Redux 상태 업데이트 (일반적으로 추천되지 않지만 디버깅 목적으로 사용)
        dispatch({ type: 'withcookie/setGlobalMenus', payload: newGlobalMenus });
        dispatch({ type: 'withcookie/setMainMenus', payload: newMainMenus });
      }
      
      // 테스트용 기본 메뉴 데이터 생성 및 저장 (실제 메뉴가 없는 경우에만)
      const shouldCreateTestMenus = (!Array.isArray(editorMenus) || editorMenus.length === 0) && 
                                   (!Array.isArray(globalMenus) || globalMenus.length === 0) && 
                                   (!Array.isArray(mainMenus) || mainMenus.length === 0);
      
      if (shouldCreateTestMenus) {
        
        // 테스트용 기본 메뉴 데이터
        const testMainMenus = [
          {
            id: 'main-1',
            name: '협회 소개',
            path: '/greeting',
            type: 'MAIN',
            parentId: null,
            order: 1,
            visible: true,
            components: []
          },
          {
            id: 'main-2',
            name: '협회 사업',
            path: '/environmental-program',
            type: 'MAIN',
            parentId: null,
            order: 2,
            visible: true,
            components: []
          },
          {
            id: 'main-3',
            name: '커뮤니티',
            path: '/notice',
            type: 'MAIN',
            parentId: null,
            order: 3,
            visible: true,
            components: []
          },
          {
            id: 'main-4',
            name: '자료실',
            path: '/data-room',
            type: 'MAIN',
            parentId: null,
            order: 4,
            visible: true,
            components: []
          },
          {
            id: 'main-5',
            name: '후원 안내',
            path: '/donation',
            type: 'MAIN',
            parentId: null,
            order: 5,
            visible: true,
            components: []
          },
          {
            id: 'main-6',
            name: '로그인',
            path: '/login',
            type: 'MAIN',
            parentId: null,
            order: 6,
            visible: true,
            components: []
          },
          // 서브메뉴
          {
            id: 'sub-1-1',
            name: '인사말',
            path: '/greeting',
            type: 'MAIN',
            parentId: 'main-1',
            order: 1,
            visible: true,
            components: []
          },
          {
            id: 'sub-1-2',
            name: '설립허가 및 고유번호증',
            path: '/license',
            type: 'MAIN',
            parentId: 'main-1',
            order: 2,
            visible: true,
            components: []
          },
          {
            id: 'sub-1-3',
            name: '조직도',
            path: '/organization-chart',
            type: 'MAIN',
            parentId: 'main-1',
            order: 3,
            visible: true,
            components: []
          },
          {
            id: 'sub-1-4',
            name: '협회비전',
            path: '/vision',
            type: 'MAIN',
            parentId: 'main-1',
            order: 4,
            visible: true,
            components: []
          },
          {
            id: 'sub-1-5',
            name: '협회 CI',
            path: '/ci',
            type: 'MAIN',
            parentId: 'main-1',
            order: 5,
            visible: true,
            components: []
          }
        ];
        
        // 메뉴 데이터 설정
        dispatch({ type: 'withcookie/setMainMenus', payload: testMainMenus });
        
        // 에디터 메뉴 상태도 업데이트
        dispatch(setMenus(testMainMenus));
      }
    }, 5000);
    
    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch, globalMenus, mainMenus, editorMenus]);
  
  return (
    <div style={{ display: 'none' }}>
      {/* 숨겨진 디버그 컴포넌트 */}
    </div>
  );
};

export default MenuDebug; 